import styled from "styled-components"

import { minWidth, maxWidth, when } from "utils"

export const Container = styled.div`
  margin-top: 5rem;
  color: ${({ theme }) => theme.component.text};

  ${({ theme }) =>
    !theme.component.isNested &&
    `
      margin: 0 auto;
      padding: 8rem 0;
      padding-left: calc((100% - 74rem) / 2);
      padding-right: calc((100% - 74rem) / 2);
      text-align: center;
    `}

  ${when("noMargin")`
    margin-top: 0;
  `}

  ${maxWidth.mobile`
    padding: 0 2.5rem 2.5rem 2.5rem;
    ${({ theme }) => !theme.component.isNested && "padding: 2.5rem;"}
  `}
`

export const Badges = styled.div`
  display: flex;

  ${maxWidth.mobile`
    flex-direction: column;
  `}

  > :first-child {
    margin-right: 1rem;

    ${maxWidth.mobile`
      margin-right: 0;
      margin-bottom: 1rem;
    `}
  }
`

export const Badge = styled.button`
  border: 0.45rem solid white;
  box-shadow: 0 2px 11px 0 rgba(145, 145, 145, 0.35);
  padding: 2rem;
  background: #f5f5f5;
  text-align: center;
  border-radius: 0.9rem;

  flex: 1;

  h5 {
    text-transform: uppercase;
    font-size: 1.5rem;
    letter-spacing: 0.188rem;
  }

  p {
    font-weight: 500;
    font-size: 2.8rem;
    text-transform: uppercase;
    margin: 1rem 0 0 0;
  }

  ${when("active")`
    border-color: ${({ theme }) => theme.component.highlight};
  `}
`

export const AffirmBadge = styled(Badge)`
  position: relative;

  ::after {
    position: absolute;
    bottom: 110%;
    left: calc(50% - 4.5rem);
    width: 9rem;
    height: 2.7rem;
    background: url("https://mindbodygreen-res.cloudinary.com/image/upload/c_fill,g_auto,w_90,h_27,q_auto,f_auto,fl_lossy/v1607520562/classes/affirm_logo.png");
    content: "";
    display: block;
  }
`

export const AddToCartButton = styled.button`
  width: 100%;
  margin: 1.7rem 0;
  padding: 1.1rem 1.8rem;
  border-radius: 3rem;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
  background: ${({ theme }) => theme.component.cta};
  color: ${({ theme }) => theme.colors.text.alternate};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  ${minWidth.tablet`
    ${({ theme }) =>
      !theme.component.isNested &&
      `
      width: unset;
      min-width: 19.2rem;
      margin: 1.7rem auto;
      padding: 1.2rem 4.2rem;
      display: block;
    `}
  `}
`

export const AllAccessButton = styled(AddToCartButton)`
  margin-top: 0;
  background: ${({ theme }) => theme.component.category};
`

export const UnlockDisclaimer = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  text-transform: uppercase;
  color: #767676;

  a {
    text-decoration: underline;
    color: ${({ theme }) => theme.component.category};
  }
`
